var _path, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForwardButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.925 13.6195C19.8773 13.4968 19.8059 13.3848 19.7149 13.2897L14.7128 8.29385C14.6195 8.20069 14.5088 8.12679 14.3869 8.07637C14.265 8.02595 14.1344 8 14.0025 8C13.7361 8 13.4806 8.1057 13.2922 8.29385C13.1989 8.38701 13.1249 8.49761 13.0744 8.61933C13.024 8.74105 12.998 8.87151 12.998 9.00326C12.998 9.26935 13.1038 9.52453 13.2922 9.71268L16.5936 13H9.00042C8.73509 13 8.48063 13.1052 8.29302 13.2926C8.1054 13.48 8 13.7341 8 13.9991C8 14.2641 8.1054 14.5183 8.29302 14.7057C8.48063 14.8931 8.73509 14.9983 9.00042 14.9983H16.5936L13.2922 18.2856C13.1984 18.3785 13.124 18.489 13.0732 18.6108C13.0224 18.7325 12.9963 18.8631 12.9963 18.995C12.9963 19.1269 13.0224 19.2575 13.0732 19.3793C13.124 19.501 13.1984 19.6116 13.2922 19.7044C13.3852 19.7981 13.4958 19.8724 13.6178 19.9232C13.7397 19.9739 13.8704 20 14.0025 20C14.1346 20 14.2653 19.9739 14.3872 19.9232C14.5091 19.8724 14.6198 19.7981 14.7128 19.7044L19.7149 14.7086C19.8059 14.6135 19.8773 14.5015 19.925 14.3788C20.025 14.1356 20.025 13.8627 19.925 13.6195Z",
    fill: "url(#paint0_linear_5402_116665)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 26,
    height: 26,
    rx: 13,
    stroke: "url(#paint1_linear_5402_116665)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5402_116665",
    x1: 12.1304,
    y1: 17,
    x2: 20.366,
    y2: 15.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44A1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5402_116665",
    x1: 9.63768,
    y1: 21,
    x2: 28.854,
    y2: 18.0834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44A1FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardButton);
export default __webpack_public_path__ + "static/media/ForwardButton.6ba2cb7a8128ba913f409f162e8e09f4.svg";
export { ForwardRef as ReactComponent };